import type { Settings } from "../types";
import type { ToolId } from "./IntegratedTools";
import { ToolIcon } from "./ToolIcon";
import { SectionHeader } from "./SectionHeader";
import { toolText, type ToolText } from "../lib/toolCopy";
import "./tools.css";
import "./menu-density.css";
const entries: ToolId[] = ["battery","session","range","fuel","charging","warranty"];
export function ToolsCatalog({language,onOpen,onBack,vehicle}:{language:Settings["language"];onOpen:(id:ToolId)=>void;onBack?:()=>void;vehicle?:{name:string;image:string}}) {
  const tr=(k:ToolText)=>toolText(language,k);
  return <section className="screen precision-tools tools-list-page" data-native-i18n lang={language}>
    <SectionHeader className="tools-page-top" title={tr("tools")} language={language} onBack={onBack}/>
    {vehicle&&<div className="tools-vehicle-intro"><div><b>{vehicle.name}</b><p>{tr("intro")}</p></div><img src={vehicle.image} alt={vehicle.name} onError={e=>{e.currentTarget.style.visibility="hidden";}}/></div>}
    <div className="tools-menu">{entries.map(id=><button className="tools-menu-row" key={id} onClick={()=>onOpen(id)}><i><ToolIcon name={id}/></i><span><b>{tr(id)}</b></span><svg className="tools-chevron" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden><path d="m9 5 7 7-7 7"/></svg></button>)}</div>
  </section>;
}
